export default {
  // Page title
  'page.title': 'Minuteur',

  // Popular timers
  'popular.title': 'Minuteurs Populaires',
  'popular.10s': 'Minuteur 10 Secondes',
  'popular.20s': 'Minuteur 20 Secondes',
  'popular.30s': 'Minuteur 30 Secondes',
  'popular.40s': 'Minuteur 40 Secondes',
  'popular.50s': 'Minuteur 50 Secondes',
  'popular.90s': 'Minuteur 1,5 Minute',
  'popular.2minute': 'Minuteur 2 Minutes',
  'popular.3minute': 'Minuteur 3 Minutes',
  'popular.5minute': 'Minuteur 5 Minutes',
  'popular.10minute': 'Minuteur 10 Minutes',
  'popular.15minute': 'Minuteur 15 Minutes',
  'popular.30minute': 'Minuteur 30 Minutes',
  'popular.60minute': 'Minuteur 60 Minutes',
  'popular.1hour': 'Minuteur 1 Heure',
  'popular.10hour': 'Minuteur 10 Heures',
  'popular.24hour': 'Minuteur 24 Heures',
  'popular.48hour': 'Minuteur 48 Heures',

  // How to use
  'howto.title': 'Comment Régler un Minuteur',
  'howto.titleMinutes': 'Comment Régler un Minuteur de {{minutes}} Minute',
  'howto.titleSeconds': 'Comment Régler un Minuteur de {{seconds}} Secondes',
  'howto.titleHour': 'Comment Régler un Minuteur de {{hours}} Heure',
  'howto.titleHours': 'Comment Régler un Minuteur de {{hours}} Heures',
  'howto.step1': '⚙️ Réglez Votre Temps : Cliquez sur les chiffres des heures ou des minutes pour modifier directement le temps. Vous pouvez régler jusqu\'à 23 heures et 59 minutes pour n\'importe quelle tâche.',
  'howto.step2': '⚡ Ajustement Rapide : Utilisez les boutons d\'ajout rapide pour ajouter instantanément 30 secondes, 1 minute, 5 minutes, 10 minutes ou 30 minutes à votre minuteur.',
  'howto.step3': '▶️ Démarrer et Contrôler : Cliquez sur "Démarrer" pour lancer le compte à rebours. Vous pouvez mettre en pause à tout moment pour faire une pause et reprendre quand vous êtes prêt, ou réinitialiser pour recommencer.',
  'howto.step4': '🔔 Recevez des Notifications : Recevez des notifications de bureau et des alertes sonores personnalisables lorsque le temps est écoulé. Activez/désactivez le son dans le coin supérieur droit.',
  'howto.step5': '🖥️ Mode Plein Écran : Cliquez sur le bouton plein écran pour un chronométrage sans distraction - parfait pour les présentations, la méditation ou les séances de travail concentré.',
  'howto.step6': '📱 Fonctionne Partout : Utilisez sur n\'importe quel appareil - ordinateur, tablette ou mobile. Aucun téléchargement requis, fonctionne directement dans votre navigateur.',

  // User review submission
  'reviewSubmission.title': 'Partagez Votre Expérience',
  'reviewSubmission.subtitle': 'Aidez les autres à découvrir ce minuteur en partageant votre expérience',
  'reviewSubmission.ratingLabel': 'Évaluez votre expérience',
  'reviewSubmission.commentLabel': 'Votre avis (facultatif)',
  'reviewSubmission.commentPlaceholder': 'Dites-nous comment ce minuteur vous a aidé pour la productivité, la cuisine, les études ou toute autre activité...',
  'reviewSubmission.nameLabel': 'Votre nom (facultatif)',
  'reviewSubmission.namePlaceholder': 'Comment devons-nous afficher votre nom ?',
  'reviewSubmission.submitButton': 'Soumettre l\'Avis',
  'reviewSubmission.thankYou': 'Merci pour votre avis !',
  'reviewSubmission.thankYouMessage': 'Vos commentaires nous aident à nous améliorer et aident les autres à découvrir notre minuteur.',
  'reviewSubmission.error': 'Veuillez sélectionner une note avant de soumettre.',

  // User reviews
  'reviews.title': 'Ce Que Disent Nos Utilisateurs',
  'reviews.newReview': 'Nouvel Avis',
  'reviews.mikeZhang': 'Révolutionnaire pour ma productivité ! La technique Pomodoro avec ce minuteur m\'a aidé à terminer ma thèse. Interface épurée, sans distractions.',
  'reviews.lisaLee': 'Parfait pour le chronométrage en cuisine ! Plus jamais d\'œufs trop cuits. Les alertes sonores sont assez fortes mais pas ennuyeuses. Ma mère âgée l\'adore aussi.',
  'reviews.johnDeveloper': 'Meilleur minuteur de pause de codage ! Les boutons préréglés font gagner beaucoup de temps. Aide à prévenir la fatigue oculaire et me garde concentré pendant les sprints.',
  'reviews.msChen': 'A transformé ma gestion de classe ! Les élèves apprécient vraiment les activités chronométrées maintenant. Le compte à rebours visuel garde tout le monde engagé.',
  'reviews.fitnessPro': 'Révolutionnaire pour les entraînements HIIT ! Chronométrage précis, commandes faciles même avec les mains en sueur. Mes clients adorent le mode plein écran.',
  'reviews.sarahMarketer': 'A augmenté l\'efficacité de mes réunions de 40 % ! Fini les discussions sans fin. Les limites de temps forcent les décisions et gardent tout le monde concentré.',
  'reviews.tomChef': 'Essentiel dans ma cuisine de restaurant ! Pâtes, steaks, sauces - un chronométrage parfait à chaque fois. Les multiples boutons d\'ajout rapide sont géniaux.',
  'reviews.amyStudent': 'Révolutionnaire pour les études ! Brise le cycle de procrastination avec des portions de temps gérables. Je suis passée des notes C aux A grâce à cette méthode.',
  'reviews.davidWriter': 'A guéri mon blocage d\'écrivain ! Les sprints d\'écriture de 15 minutes créent de l\'élan. J\'ai publié 3 articles ce mois-ci grâce à ce minuteur.',
  'reviews.rachelTherapist': 'Parfait pour les séances de méditation avec les clients. Les alertes douces ne brisent pas l\'atmosphère paisible. Très professionnel.',
  // Preset timer specific reviews
  'reviews.managerZhang': 'Essentiel pour le travail de bureau ! Parfait pour infuser le thé et les pauses entre réunions, l\'interface épurée ne distrait pas du travail.',
  'reviews.mrsLi': 'Minuteur d\'œufs parfait ! Les œufs mollets de 3 minutes sont parfaits à chaque fois, les alertes sonores sont très réfléchies, pas d\'œufs trop cuits.',
  'reviews.programmerWang': 'Essentiel pour les exercices oculaires pendant les pauses de codage, 3 minutes est juste suffisant pour détendre les muscles oculaires, excellent pour la protection de la vue !',

  // Use cases
  'useCases.title': 'Cas d\'Utilisation du Minuteur de {{minutes}} Minutes',
  'useCases.titleSeconds': 'Cas d\'Utilisation du Minuteur de {{seconds}} Secondes',
  'useCases.titleHours': 'Cas d\'Utilisation du Minuteur de {{hours}} Heures',

  // Page titles
  'pageTitle': 'Minuteur {{minutes}} Minutes',
  'pageTitleSeconds': 'Minuteur {{seconds}} Secondes',
  'pageTitleHour': 'Minuteur {{hours}} Heure',
  'pageTitleHours': 'Minuteur {{hours}} Heures',

  // User names
  'user.mikeZhang': 'Mike Zhang',
  'user.lisaLee': 'Lisa Lee',
  'user.johnDeveloper': 'John Développeur',
  'user.msChen': 'Mme Chen',
  'user.fitnessPro': 'Pro Fitness',
  'user.sarahMarketer': 'Sarah Marketing',
  'user.tomChef': 'Chef Tom',
  'user.amyStudent': 'Amy Étudiante',
  'user.davidWriter': 'David Écrivain',
  'user.rachelTherapist': 'Rachel Thérapeute',
  // Preset timer specific users
  'user.managerZhang': 'Manager Zhang',
  'user.mrsLi': 'Mme Li',
  'user.programmerWang': 'Programmeur Wang',

  // Use cases
  'useCases.quickBreak.title': 'Pause Rapide',
  'useCases.quickBreak.desc': 'Courte pause entre les sessions de travail pour rafraîchir votre esprit et prévenir l\'épuisement',
  'useCases.eyeCare.title': 'Rappel de Soin des Yeux',
  'useCases.eyeCare.desc': 'Suivez la règle 20-20-20 : toutes les 20 minutes, regardez quelque chose à 6 mètres pendant 20 secondes',
  'useCases.teaBrewing.title': 'Infusion du Thé',
  'useCases.teaBrewing.desc': 'Temps d\'infusion parfait pour le thé vert (3min), le thé noir (5min) ou les mélanges de plantes',
  'useCases.lightExercise.title': 'Exercice Léger',
  'useCases.lightExercise.desc': 'Étirements au bureau, yoga de bureau ou exercices simples pour combattre la sédentarité',
  'useCases.meditation.title': 'Pleine Conscience et Méditation',
  'useCases.meditation.desc': 'Exercices de respiration guidée, pratique de la pleine conscience ou méditation anti-stress',
  'useCases.softBoiledEggs.title': 'Minuteur de Cuisine',
  'useCases.softBoiledEggs.desc': 'Chronométrage parfait pour les œufs mollets (5min), la cuisson des pâtes ou toute tâche en cuisine',
  'useCases.quickReading.title': 'Lecture Concentrée',
  'useCases.quickReading.desc': 'Sessions de lecture concentrée pour les livres, articles ou matériel d\'étude',
  'useCases.phoneCall.title': 'Minuteur d\'Appels et Réunions',
  'useCases.phoneCall.desc': 'Gardez les appels téléphoniques sur la bonne voie, limitez la durée des réunions ou chronométrez les présentations',
  'useCases.focusedWork.title': 'Sessions de Travail Pomodoro',
  'useCases.focusedWork.desc': 'Technique Pomodoro classique - 25 minutes de travail concentré suivies d\'une pause',
  'useCases.exercise.title': 'Entraînement et Exercice',
  'useCases.exercise.desc': 'Intervalles de haute intensité, entraînement en circuit ou durée d\'exercice spécifique',
  // 15-minute specific
  'useCases.shortMeeting.title': 'Réunions Debout',
  'useCases.shortMeeting.desc': 'Mises à jour rapides de l\'équipe, stand-ups quotidiens ou discussions collaboratives brèves',
  'useCases.powerNap.title': 'Sieste Énergisante',
  'useCases.powerNap.desc': 'Durée de sieste optimale pour un regain d\'énergie sans somnolence',
  'useCases.learning.title': 'Sessions d\'Apprentissage',
  'useCases.learning.desc': 'Pratique de langue, tutoriels de compétences ou segments vidéo éducatifs',
  'useCases.creativity.title': 'Sprints Créatifs',
  'useCases.creativity.desc': 'Sessions de brainstorming, sprints d\'écriture ou pratique artistique',
  // 30-minute specific
  'useCases.deepWork.title': 'Session de Travail Profond',
  'useCases.deepWork.desc': 'Travail concentré prolongé avec interruptions minimales pour les tâches complexes',
  'useCases.workout.title': 'Entraînement Complet',
  'useCases.workout.desc': 'Routine d\'exercice complète, session de yoga ou programme d\'entraînement structuré',
  'useCases.study.title': 'Bloc d\'Étude',
  'useCases.study.desc': 'Sessions d\'étude intensive pour les examens, la recherche ou le développement de compétences',
  'useCases.presentation.title': 'Pratique de Présentation',
  'useCases.presentation.desc': 'Répétez des discours, pratiquez des pitchs ou chronométrez la prestation de présentation',

  // Timer-specific user reviews
  // 1-minute timer users
  'user.officeWorkerAlex': 'Alex Bureau',
  'user.developerSarah': 'Sarah Dev',
  'user.designerMike': 'Mike Design',
  'reviews.officeWorkerAlex': 'Parfait pour les pauses rapides entre les réunions ! Juste 1 minute pour s\'étirer et se recentrer fait une énorme différence.',
  'reviews.developerSarah': 'Excellent pour la règle 20-20-20 - toutes les 20 minutes, je regarde quelque chose à 6 mètres pendant 1 minute. Mes yeux se sentent beaucoup mieux !',
  'reviews.designerMike': 'J\'utilise ceci pour des micro-pauses pendant le travail de design intensif. Court mais efficace pour prévenir l\'épuisement.',

  // 3-minute timer users
  'user.teaLoverEmily': 'Emily Thé',
  'user.yogatrainerJohn': 'John Yoga',
  'user.busyMomLisa': 'Lisa Maman',
  'reviews.teaLoverEmily': 'Chronométrage parfait pour mon thé vert ! 3 minutes donnent la saveur parfaite sans amertume. J\'adore l\'alerte sonore !',
  'reviews.yogatrainerJohn': 'J\'utilise ceci pour des exercices de respiration rapides avec les clients. 3 minutes est juste bon pour une session apaisante.',
  'reviews.busyMomLisa': 'Super pour chronométrer le brossage de dents de mes enfants. Ils apprécient vraiment le compte à rebours maintenant !',

  // 5-minute timer users
  'user.meditatorZen': 'Maître Zen',
  'user.chefTony': 'Chef Tony',
  'user.runnerMia': 'Mia Coureuse',
  'reviews.meditatorZen': 'Parfait pour la méditation des débutants. 5 minutes est gérable mais efficace pour la pratique de la pleine conscience.',
  'reviews.chefTony': 'Essentiel dans ma cuisine ! Chronométrage parfait pour les œufs mollets à chaque fois. Professionnel et fiable.',
  'reviews.runnerMia': 'J\'utilise ceci pour les étirements après la course. 5 minutes garantissent que je ne saute pas ma routine de récupération !',

  // 10-minute timer users
  'user.studentDavid': 'David Étudiant',
  'user.managerRachel': 'Rachel Manager',
  'user.writerJames': 'James Écrivain',
  'reviews.studentDavid': 'Super pour les pauses d\'étude ! 10 minutes est parfait pour une réinitialisation mentale sans perdre l\'élan.',
  'reviews.managerRachel': 'J\'utilise ceci pour des sessions de lecture concentrée. 10 minutes de lecture ininterrompue s\'accumulent vraiment !',
  'reviews.writerJames': 'Parfait pour les sprints d\'écriture chronométrés. La pression de 10 minutes m\'aide à surmonter le blocage de l\'écrivain.',

  // 15-minute timer users
  'user.consultantAmy': 'Amy Consultante',
  'user.teacherBen': 'Ben Professeur',
  'user.freelancerSophie': 'Sophie Freelance',
  'reviews.consultantAmy': 'Idéal pour les appels clients rapides et les réunions debout. Garde les discussions concentrées et productives.',
  'reviews.teacherBen': 'J\'utilise ceci pour les activités en classe et le travail de groupe. Les élèves restent engagés avec la limite de temps.',
  'reviews.freelancerSophie': 'Sessions Pomodoro parfaites ! 15 minutes de travail concentré suivies d\'une pause me gardent productive toute la journée.',

  // 30-minute timer users
  'user.executiveRobert': 'Robert Exécutif',
  'user.fitnessCoachMaya': 'Maya Fitness',
  'user.artistOlivia': 'Olivia Artiste',
  'reviews.executiveRobert': 'Excellent pour les sessions de travail profond. 30 minutes permettent des progrès significatifs sans engagement écrasant.',
  'reviews.fitnessCoachMaya': 'Parfait pour les circuits d\'entraînement complets. Mes clients adorent le chronométrage structuré pour différents exercices.',
  'reviews.artistOlivia': 'Super pour les sessions créatives. 30 minutes donnent assez de temps pour entrer dans l\'état de flow et créer quelque chose de significatif.',
};
